import React, { useRef } from "react";
import { scrollToRef } from "../../../helpers/scroll_to_ref";
import SubEmployerFaq from "../SubEmployerFaq/SubEmployerFaq";
import SubEmployerFooter from "../SubEmployerFooter/SubEmployerFooter";
import SubEmployerHeader from "../SubEmployerHeader/SubEmployerHeader";
import SubEmployerHiringPackage from "../SubEmployerHiringPackage/SubEmployerHiringPackage";
import SubEmployerHiringPackageInfo from "../SubEmployerHiringPackageInfo/SubEmployerHiringPackageInfo";
import SubEmployerIntro from "../SubEmployerIntro/SubEmployerIntro";
import SubEmployerMore from "../SubEmployerMore/SubEmployerMore";
import { Wrapper } from "./styles";

function SubEmployerPage() {
  const packageRef = useRef(null);

  return (
    <>
      <Wrapper>
        <SubEmployerHeader
          onScrollToPackage={() => scrollToRef(packageRef, 80)}
        />
        <SubEmployerIntro />
        <div ref={packageRef}>
          <SubEmployerHiringPackage />
        </div>
        <SubEmployerHiringPackageInfo />
        <SubEmployerMore />
        <SubEmployerFaq />
        <SubEmployerFooter />
      </Wrapper>
    </>
  );
}

export default SubEmployerPage;
